// ES5 syntax is used for l10n utils

module.exports = {
    messages: require('./messages'),
    amateur_film: require('./amateur_film'),
    disclaimer: require('./disclaimer'),
    gender_select: require('./gender_select'),
    location_select: require('./location_select'),
    mybobtv: require('./mybobtv'),
    member_photo: require('./member_photo'),
    meta: require('./meta'),
    xxl: require('./xxl'),
    virtual_gifts: require('./virtual_gifts'),
    amateur_films: require('./amateur_films'),
    wall_material: require('./wall_material'),
    notifications: require('./notifications.js'),
    delete: require('./delete'),
    alt: require('./alt'),
};


// WEBPACK FOOTER //
// ./src/l10n-messages/fr/index.js